import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import CarrierLogos from "./CarrierLogos"

const CarrierSlider = () => {

  const data = useStaticQuery(graphql`
          query CarrierLogoQuery {
            carriers: allMarkdownRemark(filter: {fields: {collection: {eq: "carriers"}}}) {
              edges {
                node {
                  id
                  frontmatter {
                    carrier_logo {
                      childImageSharp {
                        id
                        fluid {
                          src
                        }
                      }
                    }
                    carrier_name
                  }
                  fields {
                    collection
                    slug
                  }
                }
              }
            }
          }`)

  return (
    <>
      <div className="logos">
        <CarrierLogos data={data} key={1} />
        <CarrierLogos data={data} key={2} />
      </div>

    </>
  )
}

export default CarrierSlider
